import {useIsDesktop} from '@eCommerce/frontend-legacy-shared-library-native';
import {View} from 'native-base';
import React from 'react';

const OfferDetailsButtonSpacing = () => {
  const isDesktop = useIsDesktop();

  return (
    <View
      width={isDesktop ? 2 : undefined}
      height={isDesktop ? undefined : 2}
    />
  );
};

export default OfferDetailsButtonSpacing;
